import React from 'react';
import { useHistory } from 'react-router-dom';
import { TableCell, TableRow, Grid } from '@material-ui/core';
import moment from 'moment';
import API from 'apis/API';
import Routes from 'router/Routes';
import PaginatedTable from 'components/Table/PaginatedTable';
import { ViewIconButton, DeleteIconButton } from 'components/Buttons/IconButtons';
import FillButton from "../../components/Buttons/FillButton";
import { useParams } from "react-router-dom";
//import getTelemetryModulesName from "../../utils/getTelemetryModulesName";

const StudentsActivityPerFrom = props => {
    const history = useHistory();
    let { from, timeFrom, timeTo, timeMode } = useParams();
    if (timeFrom == 'false')
    {
        timeFrom = false
    }
    if (timeTo == 'false')
    {
        timeTo = false
    }
    if (timeMode == 'false')
    {
        timeMode = false
    }
    const { title } = props;

    const columns = [
        {
            title: 'Akcja',
            name: 'to',
        },
        {
            title: 'Liczba kliknięć',
            name: 'clicks',
        },
        {
            title: 'Liczba osób',
            name: 'students',
            width: 100
        }
    ];

    const renderRow = (item, index) => (
        <TableRow key={index} >
            <TableCell>{/*getTelemetryModulesName*/(item.to)}</TableCell>
            <TableCell>{item.clicks}</TableCell>
            <TableCell>{item.students}</TableCell>
        </TableRow>
    );

    const goBack = () => {
        history.push(Routes.Students.ActivityCustom(timeMode, timeFrom, timeTo))
    }

    const buttons = [
        {
            component: FillButton,
            title: 'Wróć',
            onClick: goBack
        },
    ];

    let timeString = ''
    if (timeFrom > 0 || timeTo > 0 || timeMode > 0)
    {
        timeString += ' ('   
        if (timeMode == 1)
        {            
            timeString += 'W zeszłym tygodniu'
        }
        else if (timeMode == 2)
        {
            timeString += 'W zeszłym miesiącu'
        }
        else if (timeMode == 3)
        {
            timeString += 'W zeszłym roku'
        }
        else if (timeMode == 4)
        {
            if (timeFrom)
            {
                timeString += ' Od ' + moment.unix(timeFrom / 1000).format('DD.MM.YYYY') + ' '
            }
            if (timeTo)
            {
                timeString += ' Do ' + moment.unix(timeTo / 1000).format('DD.MM.YYYY') + ' '
            }
        }
        timeString += ')'
    }

    return (
        <PaginatedTable
            title={'Działania w module: ' + from + timeString}
            buttons={buttons}
            endpoint={params => API.students.activityFrom({
                ...params,
                from,
                ...(!!timeFrom ? {timeFrom} : {}),
                ...(!!timeTo ? {timeTo} : {}),
            })}
            columns={columns}
            renderRow={renderRow}
        />
    );
};

export default StudentsActivityPerFrom;
